import React, { useEffect, useState } from "react";
import { useNavigate, Navigate } from 'react-router-dom';
import { baseUrl } from "../shared";
import '../pages/App.css';
import { Toggle } from './ui';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function PermissionRow({ label, checked, onToggle, index }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        py: 1.25,
        background: index % 2 === 0 ? 'var(--surface-2)' : 'var(--surface)',
      }}
    >
      <Typography sx={{ fontSize: 14 }}>{label}</Typography>
      <Toggle checked={checked} onChange={onToggle} ariaLabel={label} />
    </Box>
  );
}

export function UpdateUser() {
  const [changed, setChanged] = useState(false);
  var [userEdit, setUserEdit] = useState({});
  var [modUser, setModUser] = useState({});
  var [userList, setUserList] = useState([]);
  const [usersLoaded, setusersLoaded] = useState(false);
  const [userSelected, setUserSelected] = useState(false);
  var [nameKey, setNameKey] = useState();
  var [emailKey, setEmailKey] = useState();
  var [phoneKey, setPhoneKey] = useState();
  const navigate = useNavigate();

  const [updateUser] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [successOpen, setSuccessOpen] = React.useState(false);
  const [failOpen, setFailOpen] = React.useState(false);
  const [message, setMessage] = useState('');

  const handleClose = () => setOpen(false);
  const handleFailClose = () => setFailOpen(false);
  const handleProceedClose = (e) => {
    userUpdate(e);
    setOpen(false);
  };
  const handleSuccessClose = () => {
    <Navigate to={'/admin/'} />;
    { navigate(0); }
  };
  const cancelUpdateUser = () => {
    <Navigate to={'/admin/'} />;
    { navigate(0); }
  };

  useEffect(() => {
    if (usersLoaded === false) {
      const url = baseUrl + 'user/list/';
      fetch(url, {
        method: 'GET',
        headers: {
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken'),
        },
      })
        .then((res) => res.json())
        .then((json) => {
          setUserList(json);
          setusersLoaded(true);
        })
        .catch((err) => console.log(err.message));
    }
  });

  async function userUpdate(e) {
    e.preventDefault();
    const url = baseUrl + 'user/update';
    await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'username': localStorage.getItem('username'),
        'bToken': localStorage.getItem('bToken'),
        'selUserId': modUser.id,
      },
      body: (JSON.stringify(modUser)),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setMessage(data.message);
          setSuccessOpen(true);
        } else if (data.status === 401) {
          setMessage(data.message);
          setFailOpen(true);
        }
      })
      .catch((err) => {
        setMessage(err.message);
        setFailOpen(true);
      });
  }

  function userDetails(e) {
    const url = baseUrl + 'user/details';
    fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'username': localStorage.getItem('username'),
        'bToken': localStorage.getItem('bToken'),
      },
      body: ("json", JSON.stringify({ "selUserId": e })),
    })
      .then((response) => {
        if (!response.ok) throw new Error('something went wrong');
        return response.json();
      })
      .then((data) => {
        setUserEdit(data[0]);
        setModUser(data[0]);
        setNameKey(`${Math.floor((Math.random() * 1000))}-min`);
        setPhoneKey(`${Math.floor((Math.random() * 1000))}-min`);
        setEmailKey(`${Math.floor((Math.random() * 1000))}-min`);
      });
  }

  const flip = (field) => () => {
    setChanged(true);
    setModUser({ ...modUser, [field]: modUser[field] ? 0 : 1 });
  };

  if (!(updateUser && localStorage.getItem('canAdmin') === '1')) return null;

  return (
    <Card sx={{ p: { xs: 2.5, md: 3.5 }, maxWidth: 560, mx: 'auto' }}>
      <React.Fragment>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle />
          <DialogContent>
            <DialogContentText>Confirm Update User Details</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button variant="contained" onClick={handleProceedClose}>Proceed</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog open={successOpen} onClose={handleSuccessClose}>
          <DialogTitle />
          <DialogContent>
            <DialogContentText>{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleSuccessClose}>Ok</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog open={failOpen} onClose={handleFailClose}>
          <DialogTitle />
          <DialogContent>
            <DialogContentText>{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleFailClose}>Ok</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>Update Existing User</Typography>

      <FormControl margin="dense" fullWidth>
        <InputLabel id="usernameTitleLabel">Username</InputLabel>
        <Select
          labelId="usernameTitleLabel"
          label="Username"
          value={modUser.id ?? ''}
          onChange={(e) => {
            setUserSelected(true);
            userDetails(e.target.value);
          }}
        >
          <MenuItem value="" disabled>Select Username to Modify</MenuItem>
          {userList.map((u) => (
            <MenuItem value={u.id} key={u.id}>{u.username}</MenuItem>
          ))}
        </Select>
      </FormControl>

      {userSelected ? (
        <>
          <TextField fullWidth margin="dense" label="Name" variant="outlined" key={nameKey} value={modUser.name ?? ''} type="text" onChange={(e) => { setChanged(true); setModUser({ ...modUser, name: e.target.value }); }} />
          <TextField fullWidth margin="dense" label="Phone Number" variant="outlined" key={phoneKey} defaultValue={modUser.phone} type="text" onChange={(e) => { setChanged(true); setModUser({ ...modUser, phone: e.target.value }); }} />
          <TextField fullWidth margin="dense" label="E-Mail Address" variant="outlined" key={emailKey} defaultValue={modUser.email} type="text" onChange={(e) => { setChanged(true); setModUser({ ...modUser, email: e.target.value }); }} />
          <TextField fullWidth margin="dense" label="Default Rate" variant="outlined" value={modUser.defaultRate ?? ''} type="text" onChange={(e) => { setChanged(true); setModUser({ ...modUser, defaultRate: e.target.value }); }} />

          <Typography sx={{ mt: 2.5, mb: 1, fontWeight: 700, fontSize: 13, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.4px' }}>
            Permissions
          </Typography>
          <Box sx={{ border: '1px solid var(--border)', borderRadius: 'var(--r-sm)', overflow: 'hidden' }}>
            <PermissionRow index={0} label="Is Payroll User" checked={modUser.isPayroll} onToggle={flip('isPayroll')} />
            <PermissionRow index={1} label="Is Consultant User" checked={modUser.isConsultant} onToggle={flip('isConsultant')} />
            <PermissionRow index={2} label="Can Perform Admin Functions" checked={modUser.canAdmin} onToggle={flip('canAdmin')} />
            <PermissionRow index={3} label="Can Approve Consultant Time" checked={modUser.canApproveConsultant} onToggle={flip('canApproveConsultant')} />
            <PermissionRow index={4} label="Can Approve Payroll Time" checked={modUser.canApprovePayroll} onToggle={flip('canApprovePayroll')} />
            <PermissionRow index={5} label="Can Payout Money" checked={modUser.canPayout} onToggle={flip('canPayout')} />
          </Box>
        </>
      ) : null}

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
        <Button variant="outlined" color="inherit" sx={{ color: 'var(--muted)', borderColor: 'var(--border-strong)' }} onClick={cancelUpdateUser}>Cancel</Button>
        <Button variant="contained" disabled={!changed} onClick={setOpen}>Update User</Button>
      </Box>
    </Card>
  );
}

export default UpdateUser;
